import React, { useEffect, useState } from 'react';
const API_URL = process.env.REACT_APP_API_URL;

function CandidateReferralDashboard({ candidateId }) {
  const [codes, setCodes] = useState([]);
  const [history, setHistory] = useState([]);
  const [newCodeLoading, setNewCodeLoading] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editValue, setEditValue] = useState('');
  const [editError, setEditError] = useState('');
  const [copyMsg, setCopyMsg] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAll();
    // eslint-disable-next-line
  }, [candidateId]);

  const fetchAll = async () => {
    setLoading(true);
    try {
      const [codesRes, historyRes] = await Promise.all([
        fetch(`${API_URL}/api/referral/my-codes?candidate_id=${candidateId}`),
        fetch(`${API_URL}/api/referral/history?candidate_id=${candidateId}`)
      ]);
      const codesData = await codesRes.json();
      const historyData = await historyRes.json();
      setCodes(codesData.codes || []);
      setHistory(historyData.history || []);
    } catch (err) {
      // handle error
    }
    setLoading(false);
  };

  const handleGenerate = async () => {
    setNewCodeLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/referral/generate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ candidate_id: candidateId })
      });
      const data = await res.json();
      if (data.success) {
        fetchAll();
      } else {
        alert(data.error || 'Failed to generate code');
      }
    } finally {
      setNewCodeLoading(false);
    }
  };

  const handleEdit = async (id) => {
    setEditError('');
    if (!editValue || editValue.length < 4) {
      setEditError('Code must be at least 4 characters');
      return;
    }
    try {
      const res = await fetch(`${API_URL}/api/referral/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: editValue })
      });
      const data = await res.json();
      if (data.success) {
        setEditId(null);
        setEditValue('');
        fetchAll();
      } else {
        setEditError(data.error || 'Failed to edit code');
      }
    } catch (err) {
      setEditError('Failed to edit code');
    }
  };

  const handleCopy = (code) => {
    navigator.clipboard.writeText(code);
    setCopyMsg('Copied!');
    setTimeout(() => setCopyMsg(''), 1200);
  };

  return (
    <div style={{ maxWidth: 500, margin: '0 auto', padding: 24 }}>
      <h2 style={{ fontWeight: 800, fontSize: 24, color: '#5a4ff3', marginBottom: 18 }}>My Referrals</h2>
      <div style={{ marginBottom: 18 }}>
        <button className="gogig-btn" onClick={handleGenerate} disabled={codes.length >= 5 || newCodeLoading}>
          {newCodeLoading ? 'Generating...' : 'Generate New Code'}
        </button>
        <span style={{ marginLeft: 12, color: '#888' }}>(Max 5 codes)</span>
      </div>
      {loading ? <div>Loading...</div> : (
        <div style={{ marginBottom: 32 }}>
          <h4 style={{ fontWeight: 700, fontSize: 18, marginBottom: 10 }}>Your Referral Codes</h4>
          {codes.length === 0 && <div style={{ color: '#888' }}>No codes yet.</div>}
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {codes.map(code => (
              <li key={code.id} style={{ marginBottom: 14, background: '#f8fafc', borderRadius: 10, padding: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                {editId === code.id ? (
                  <>
                    <input value={editValue} onChange={e => setEditValue(e.target.value)} style={{ fontSize: 16, padding: 4, borderRadius: 6, border: '1px solid #ccc', marginRight: 8 }} />
                    <button className="gogig-btn" style={{ fontSize: 14, marginRight: 8 }} onClick={() => handleEdit(code.id)}>Save</button>
                    <button className="gogig-btn-outline" style={{ fontSize: 14 }} onClick={() => setEditId(null)}>Cancel</button>
                    {editError && <div style={{ color: 'red', marginTop: 4 }}>{editError}</div>}
                  </>
                ) : (
                  <>
                    <span style={{ fontWeight: 700, fontSize: 17, letterSpacing: 1 }}>{code.code}</span>
                    <span style={{ color: '#888', marginLeft: 10 }}>Used: {code.use_count}</span>
                    <button className="gogig-btn-outline" style={{ fontSize: 14, marginLeft: 10 }} onClick={() => { setEditId(code.id); setEditValue(code.code); }}>Edit</button>
                    <button className="gogig-btn-outline" style={{ fontSize: 14, marginLeft: 10 }} onClick={() => handleCopy(code.code)}>Copy</button>
                  </>
                )}
              </li>
            ))}
          </ul>
          {copyMsg && <div style={{ color: '#22c55e', marginTop: 8 }}>{copyMsg}</div>}
        </div>
      )}
      <div>
        <h4 style={{ fontWeight: 700, fontSize: 18, marginBottom: 10 }}>Referral History</h4>
        {history.length === 0 ? <div style={{ color: '#888' }}>No referrals yet.</div> : (
          <table style={{ width: '100%', background: '#fff', borderRadius: 10, boxShadow: '0 2px 8px rgba(90,79,243,0.07)', marginBottom: 18 }}>
            <thead>
              <tr style={{ background: '#f3f4f6' }}>
                <th style={{ padding: 8, textAlign: 'left' }}>Code</th>
                <th style={{ padding: 8, textAlign: 'left' }}>Referred</th>
                <th style={{ padding: 8, textAlign: 'left' }}>Date</th>
              </tr>
            </thead>
            <tbody>
              {history.map((h, i) => (
                <tr key={i}>
                  <td style={{ padding: 8 }}>{h.code}</td>
                  <td style={{ padding: 8 }}>{h.referred_candidate || '-'}</td>
                  <td style={{ padding: 8 }}>{new Date(h.used_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default CandidateReferralDashboard; 